export default "__VITE_ASSET__BhRUWTfK__"